export const discoverProduct = {
  name: 'Discover',
  displayName: {
    source: {
      jsonPath: '$.displayName',
      resource: 'tenant',
    },
  },
  description:
    'Identify buyer intent and personalize product search results, merchandizing and recommendations with Sitecore’s AI-powered product discovery solution.',
  icon: {
    type: 'url',
    src: 'https://sitecorecontenthub.stylelabs.cloud/api/public/content/1a0d50b5bd574889894c1d94fa1c3082',
  },
  color: 'teal',
  baseUrl: {
    dev: 'https://cec-dev.sitecore-staging.cloud',
    qa: 'https://cec-qa.sitecore-staging.cloud',
    staging: 'https://cec-staging.sitecore-staging.cloud',
    'pre-production': 'https://cec-beta.sitecorecloud.io',
    production: 'https://cec.sitecorecloud.io',
  },
  link: {
    type: 'external-link',
    to: '{baseUrl}?organization={organizationId}&tenantId={tenantId}',
    replacements: [
      {
        key: 'baseUrl',
        source: {
          jsonPath: "$.baseUrl['#env#']",
          resource: '_self',
        },
      },
      {
        key: 'organizationId',
        source: {
          resource: 'tenant',
          jsonPath: '$.organizationId',
        },
      },
      {
        key: 'tenantId',
        source: {
          resource: 'tenant',
          jsonPath: '$.id',
        },
      },
    ],
  },
};
